import { z } from 'zod';

import { RESET_PASSWORD_REASON } from '../shared';

/** Zod schema for `/auth/reset-password` URL search params. */
export const resetPasswordSearchSchema = z.object({
  /** Email address the reset code was sent to. */
  email: z.string().email(),
  /** Set when another auth flow started the reset (e.g. login refused until the password is changed). */
  reason: z.nativeEnum(RESET_PASSWORD_REASON).optional().catch(undefined)
});

/** Inferred type for the `/auth/reset-password` route search params. */
export type ResetPasswordSearch = z.infer<typeof resetPasswordSearchSchema>;
